import React, { useState, useEffect } from 'react';
import { Button, Dropdown } from 'antd';
import styled from 'styled-components';
import { AiOutlineDownload, AiOutlineGlobal } from 'react-icons/ai';

const StyledButton = styled(Button)`
  background-color: #1677ff;
  color: white;
  border: none;
  border-radius: 4px;
`;

const ViewerDownLoadButton: React.FC = () => {
  return (
    <StyledButton
      href='https://carpestore.s3.ap-northeast-2.amazonaws.com/KevinViewerSetup.exe'
      target='_blank'
    >
      <AiOutlineDownload style={{ marginRight: '8px' }} />
      Viewer
    </StyledButton>
  );
};

export default ViewerDownLoadButton;
